<section style="overflow: hidden">
  <div class="conatiner">
    <div class="row">
      <div
        class="col-12"
        style="
          display: flex;
          flex-wrap: wrap;
          align-items: start;
          justify-content: space-between;
          margin: auto;
          padding: 5%;
        "
      >
        <div class="col-lg-7 col-md-12 col-sm-12 match-details" *ngIf="match">
          <div class="match-card col-12 box-shadow">
            <div class="header col-12">
              <img
                [attr.src]="
                  match.matchImage?.url
                    ? match.matchImage.url
                    : 'assets/images/placeholder-img.jpg'
                "
                alt="match"
                loading="lazy"
              />
            </div>
            <div class="col-12 body card-content">
              <p class="teamsVSteams">
                {{ helpers.getElementTranslatedName(match.teamHome) }}
                {{ "VS" | translate }}
                {{ helpers.getElementTranslatedName(match.teamAway) }}
              </p>
              <p class="chambion-name">
                {{ helpers.getElementTranslatedName(match.champion) }}
              </p>

              <div class="stadium text-start">
                <p class="d-inline-flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    class="d-inline"
                  >
                    <path
                      d="M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z"
                      fill="#555770"
                    />
                    <path
                      d="M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z"
                      fill="#555770"
                    />
                    <path
                      d="M8.5 14.5001C8.37 14.5001 8.24 14.4701 8.12 14.4201C7.99 14.3701 7.89 14.3001 7.79 14.2101C7.61 14.0201 7.5 13.7701 7.5 13.5001C7.5 13.3701 7.53 13.2401 7.58 13.1201C7.63 13.0001 7.7 12.8901 7.79 12.7901C7.89 12.7001 7.99 12.6301 8.12 12.5801C8.48 12.4301 8.93 12.5101 9.21 12.7901C9.39 12.9801 9.5 13.2401 9.5 13.5001C9.5 13.5601 9.49 13.6301 9.48 13.7001C9.47 13.7601 9.45 13.8201 9.42 13.8801C9.4 13.9401 9.37 14.0001 9.33 14.0601C9.3 14.1101 9.25 14.1601 9.21 14.2101C9.02 14.3901 8.76 14.5001 8.5 14.5001Z"
                      fill="#555770"
                    />
                    <path
                      d="M12 14.4999C11.87 14.4999 11.74 14.4699 11.62 14.4199C11.49 14.3699 11.39 14.2999 11.29 14.2099C11.11 14.0199 11 13.7699 11 13.4999C11 13.3699 11.03 13.2399 11.08 13.1199C11.13 12.9999 11.2 12.8899 11.29 12.7899C11.39 12.6999 11.49 12.6299 11.62 12.5799C11.98 12.4199 12.43 12.5099 12.71 12.7899C12.89 12.9799 13 13.2399 13 13.4999C13 13.5599 12.99 13.6299 12.98 13.6999C12.97 13.7599 12.95 13.8199 12.92 13.8799C12.9 13.9399 12.87 13.9999 12.83 14.0599C12.8 14.1099 12.75 14.1599 12.71 14.2099C12.52 14.3899 12.26 14.4999 12 14.4999Z"
                      fill="#555770"
                    />
                    <path
                      d="M15.5 14.4999C15.37 14.4999 15.24 14.4699 15.12 14.4199C14.99 14.3699 14.89 14.2999 14.79 14.2099C14.75 14.1599 14.71 14.1099 14.67 14.0599C14.63 13.9999 14.6 13.9399 14.58 13.8799C14.55 13.8199 14.53 13.7599 14.52 13.6999C14.51 13.6299 14.5 13.5599 14.5 13.4999C14.5 13.2399 14.61 12.9799 14.79 12.7899C14.89 12.6999 14.99 12.6299 15.12 12.5799C15.49 12.4199 15.93 12.5099 16.21 12.7899C16.39 12.9799 16.5 13.2399 16.5 13.4999C16.5 13.5599 16.49 13.6299 16.48 13.6999C16.47 13.7599 16.45 13.8199 16.42 13.8799C16.4 13.9399 16.37 13.9999 16.33 14.0599C16.3 14.1099 16.25 14.1599 16.21 14.2099C16.02 14.3899 15.76 14.4999 15.5 14.4999Z"
                      fill="#555770"
                    />
                    <path
                      d="M8.5 17.9999C8.37 17.9999 8.24 17.97 8.12 17.92C8 17.87 7.89 17.7999 7.79 17.7099C7.61 17.5199 7.5 17.2599 7.5 16.9999C7.5 16.8699 7.53 16.7399 7.58 16.6199C7.63 16.4899 7.7 16.38 7.79 16.29C8.16 15.92 8.84 15.92 9.21 16.29C9.39 16.48 9.5 16.7399 9.5 16.9999C9.5 17.2599 9.39 17.5199 9.21 17.7099C9.02 17.8899 8.76 17.9999 8.5 17.9999Z"
                      fill="#555770"
                    />
                    <path
                      d="M12 17.9999C11.74 17.9999 11.48 17.8899 11.29 17.7099C11.11 17.5199 11 17.2599 11 16.9999C11 16.8699 11.03 16.7399 11.08 16.6199C11.13 16.4899 11.2 16.38 11.29 16.29C11.66 15.92 12.34 15.92 12.71 16.29C12.8 16.38 12.87 16.4899 12.92 16.6199C12.97 16.7399 13 16.8699 13 16.9999C13 17.2599 12.89 17.5199 12.71 17.7099C12.52 17.8899 12.26 17.9999 12 17.9999Z"
                      fill="#555770"
                    />
                    <path
                      d="M15.5 17.9999C15.24 17.9999 14.98 17.8899 14.79 17.7099C14.7 17.6199 14.63 17.5099 14.58 17.3799C14.53 17.2599 14.5 17.1299 14.5 16.9999C14.5 16.8699 14.53 16.7399 14.58 16.6199C14.63 16.4899 14.7 16.3799 14.79 16.2899C15.02 16.0599 15.37 15.9499 15.69 16.0199C15.76 16.0299 15.82 16.0499 15.88 16.0799C15.94 16.0999 16 16.1299 16.06 16.1699C16.11 16.1999 16.16 16.2499 16.21 16.2899C16.39 16.4799 16.5 16.7399 16.5 16.9999C16.5 17.2599 16.39 17.5199 16.21 17.7099C16.02 17.8899 15.76 17.9999 15.5 17.9999Z"
                      fill="#555770"
                    />
                    <path
                      d="M20.5 9.83984H3.5C3.09 9.83984 2.75 9.49984 2.75 9.08984C2.75 8.67984 3.09 8.33984 3.5 8.33984H20.5C20.91 8.33984 21.25 8.67984 21.25 9.08984C21.25 9.49984 20.91 9.83984 20.5 9.83984Z"
                      fill="#555770"
                    />
                    <path
                      d="M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V17C21.75 20.65 19.65 22.75 16 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z"
                      fill="#555770"
                    />
                  </svg>
                  {{
                    match.date
                      | localizedDate : "dd MMM, y" : translate.currentLang
                  }}
                </p>
                <p class="d-inline-flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    class="d-inline"
                  >
                    <path
                      d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                      fill="#555770"
                    />
                    <path
                      d="M15.71 15.93C15.58 15.93 15.45 15.9 15.33 15.82L12.23 13.97C11.46 13.51 10.89 12.5 10.89 11.61V7.51001C10.89 7.10001 11.23 6.76001 11.64 6.76001C12.05 6.76001 12.39 7.10001 12.39 7.51001V11.61C12.39 11.97 12.69 12.5 13 12.68L16.1 14.53C16.46 14.74 16.57 15.2 16.36 15.56C16.21 15.8 15.96 15.93 15.71 15.93Z"
                      fill="#555770"
                    />
                  </svg>
                  {{ helpers.convertToAMPM(match.time) }}
                </p>
                <p class="d-inline-flex">
                  <svg
                    class="d-inline"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M9.34509 19.2272C7.17937 19.0864 5.41376 18.7438 4.04826 18.1995C2.68275 17.6552 2 17.0489 2 16.3806V7.58749C2 7.22012 2.24101 6.87914 2.72303 6.56455C3.20506 6.24997 3.87563 5.9786 4.73474 5.75046C5.59387 5.5223 6.61682 5.34019 7.80359 5.20412C8.99038 5.06804 10.2797 5 11.6717 5C13.0636 5 14.3497 5.0672 15.5299 5.20159C16.71 5.33596 17.733 5.51808 18.5987 5.74793C19.4644 5.97776 20.1383 6.24997 20.6203 6.56455C21.1023 6.87914 21.3433 7.22012 21.3433 7.58749V16.3813C21.3433 17.06 20.6562 17.6687 19.2819 18.2076C17.9076 18.7465 16.138 19.0864 13.9733 19.2272C13.7575 19.2448 13.5752 19.1788 13.4263 19.029C13.2775 18.8793 13.2031 18.6983 13.2031 18.4859V14.8382H10.1402V18.4595C10.1402 18.6727 10.0617 18.8583 9.9046 19.0164C9.74748 19.1746 9.56098 19.2448 9.34509 19.2272ZM11.6717 8.80207C13.2586 8.80207 14.726 8.70863 16.0739 8.52177C17.4218 8.33492 18.4776 8.04449 19.2413 7.65046C18.8974 7.26184 17.9661 6.95177 16.4476 6.72025C14.9291 6.48871 13.3371 6.37294 11.6717 6.37294C9.95341 6.37294 8.34823 6.48431 6.85611 6.70705C5.36397 6.92977 4.44594 7.24424 4.10201 7.65046C4.86568 8.04449 5.88255 8.33492 7.15262 8.52177C8.42268 8.70863 9.92903 8.80207 11.6717 8.80207ZM8.76733 17.7994V15.1592C8.76733 14.6893 8.93372 14.2895 9.26649 13.9598C9.59925 13.6301 9.99612 13.4652 10.4571 13.4652H12.8862C13.3472 13.4652 13.7441 13.6316 14.0768 13.9644C14.4096 14.2972 14.576 14.6941 14.576 15.155V17.7994C15.7432 17.7006 16.8176 17.509 17.7992 17.2247C18.7809 16.9403 19.5046 16.6072 19.9704 16.2254V8.86498C18.9251 9.32671 17.7002 9.66047 16.2956 9.86627C14.8911 10.0721 13.3458 10.175 11.6598 10.175C9.97385 10.175 8.43252 10.0721 7.03586 9.86627C5.6392 9.66047 4.41822 9.32671 3.37292 8.86498V16.2254C3.8035 16.5896 4.50251 16.9183 5.46994 17.2115C6.43739 17.5046 7.53652 17.7006 8.76733 17.7994Z"
                      fill="#727385"
                      stroke="#727385"
                      stroke-width="0.2"
                    />
                  </svg>
                  {{ helpers.getElementTranslatedName(match.stadium) }}
                </p>
              </div>
            </div>
          </div>
          <!-- Terms & Conditions -->
          <div *ngIf="terms" class="policies mt-15 col-12 box-shadow">
            <div class="header col-12" (click)="toggleCollapse()">
              <h3>{{ "Terms and Conditions" | translate }}</h3>
              <i
                [ngClass]="{ rotate: isCollapsed }"
                class="fas fa-chevron-down"
              ></i>
            </div>
            <div class="body card-content col-12" *ngIf="!isCollapsed">
              <div class="terms-container col-12">
                <div class="conditions" [innerHTML]="terms | safeHTML"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-lg-4 col-lg-4 tickets">
          <div class="col-12 teckits_details box-shadow">
            <!-- tickets -->
            <ng-container>
              <nav class="navbar navbar-expand-lg">
                <div class="navbar-collapse">
                  <ul class="navbar-nav mr-auto ml-auto header-menu">
                    <ng-container *ngFor="let teamObj of teams">
                      <li
                        class="nav-item"
                        [ngClass]="{ active: activeTab === teamObj.id }"
                        (click)="activeTab = teamObj.id"
                      >
                        <a
                          class="nav-link"
                          style="cursor: pointer; margin-inline: 10px"
                        >
                          {{ "Tickets Club" | translate }}
                          {{ helpers.getElementTranslatedName(teamObj.team) }}
                        </a>
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </nav>
              <!-- ============================================== -->
              <!-- ticikets -->
              <div class="col-12 m-auto" style="padding: 0">
                <div *ngIf="activeTab === 'home'" class="mt-3 active-lines">
                  <ng-container *ngIf="teamHomeTickets?.length; else noTickets">
                    <div class="line" *ngFor="let ticket of teamHomeTickets">
                      <div class="col-5">
                        <span class="seet_class">{{
                          helpers.getElementTranslatedName(ticket)
                        }}</span>
                      </div>
                      <div class="col-6 text-center">
                        <ng-container *ngIf="ticket?.price !== 0">
                          <span class="seet_price">
                            <span
                              [innerHTML]="
                                ticket?.price
                                  | toVat
                                  | number : '1.2-2'
                                  | customCurrency
                                    : 'SAR'
                                    : 'symbol'
                                    : '#E5263D'
                                    : 35
                              "
                            ></span>

                            <span class="vat_notice">
                              {{ "Includnig VAT" | translate }}
                            </span>
                          </span>
                        </ng-container>

                        <span
                          *ngIf="ticket?.price === 0"
                          style="color: #e5263d; font-size: 24px"
                        >
                          {{ "free" | translate }}
                        </span>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <div *ngIf="activeTab === 'away'" class="mt-3 active-lines">
                  <ng-container *ngIf="teamAwayTickets?.length; else noTickets">
                    <div class="line" *ngFor="let ticket of teamAwayTickets">
                      <div class="col-5">
                        <span class="seet_class">
                          {{ helpers.getElementTranslatedName(ticket) }}
                        </span>
                      </div>
                      <div class="col-6 text-center">
                        <span class="seet_price">
                          <span
                            [innerHTML]="
                              ticket?.price
                                | toVat
                                | number : '1.2-2'
                                | customCurrency
                                  : 'SAR'
                                  : 'symbol'
                                  : '#E5263D'
                                  : 35
                            "
                          ></span>
                        </span>
                        <span class="vat_notice">
                          {{ "Includnig VAT" | translate }}
                        </span>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <ng-template #noTickets>
                <div class="text-center text-muted px-4 py-2">
                  {{ "No Tickets Available" | translate }}
                </div>
              </ng-template>

              <div
                class="text-center col-12"
                style="margin: auto; margin-top: 19px; padding: 0"
              >
                <button
                  class="btn btn-primary book-btn"
                  (click)="openRegisterModal()"
                  [disabled]="
                    (!ticketsAvilabilityForTeamHome &&
                      !ticketsAvilabilityForTeamAway) ||
                    !enableButtonBook()
                  "
                >
                  <ng-container
                    *ngIf="match?.status === MatchStatusEnum.ComingSoon"
                    >{{ "Sport.Soon" | translate }}</ng-container
                  >
                  <ng-container
                    *ngIf="match?.status === MatchStatusEnum.SalesOpened"
                    >{{ "Book your ticket" | translate }}</ng-container
                  >
                  <ng-container
                    *ngIf="match?.status === MatchStatusEnum.SalesClosed"
                    >{{ "Sport.SalesClosed" | translate }}</ng-container
                  >
                  <ng-container
                    *ngIf="
                      match?.status === MatchStatusEnum.EarlySales &&
                      enableButtonBook()
                    "
                    >{{ "Book your ticket" | translate }}</ng-container
                  >
                  <ng-container
                    *ngIf="
                      match?.status === MatchStatusEnum.EarlySales &&
                      !enableButtonBook()
                    "
                    >{{ "Sport.NotEligible" | translate }}</ng-container
                  >
                </button>
              </div>
            </ng-container>
          </div>

          <!-- ================================ -->
          <!-- map -->
          <div class="col-12 card-content box-shadow">
            <ng-container>
              <div class="bk-white">
                <div>
                  <div>
                    <p class="location">{{ "Match Site" | translate }}</p>

                    <a href="javascript:void(0);" (click)="openMap($event)">
                      <img
                        src="assets/images/events/map.svg"
                        style="cursor: pointer; width: -webkit-fill-available"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- ================================ -->
          <!-- sponsors -->
          <div class="col-12 sponsors-logo">
            <ng-container *ngFor="let sponsor of teamSponsors">
              <img
                [src]="sponsor.logo"
                class="homeSponsors-image"
                alt="sponsor"
                (click)="openlink(sponsor)"
              />
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>
